import { Divider, Form, Grid, TextArea } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';

import { PopupRGPD } from '@/components/Autre';

import './PayeurPanelCommentaire.less';
import type { ErrorFieldType } from '@/types';

interface PayeurPanelCommentaireProps {
  identifiant: string | number;
  // Commentaires déjà présent
  commentaire: string;
  nouveauCommentaire?: string;
  errors?: ErrorFieldType[];
  onChange?: (e: any) => void;
}

const PayeurPanelCommentaire = (props: PayeurPanelCommentaireProps) => {
  const { identifiant, commentaire, nouveauCommentaire, errors, onChange } = props;

  const handleNouveauCommentaireChange = React.useCallback(
    (e, { value }) => {
      onChange?.({
        identifiant,
        nouveauCommentaire: value,
      });
    },
    [identifiant, onChange],
  );

  const textArea = React.useMemo(
    () => (
      <TextArea
        id="commentaire"
        data-testid="textarea-commentaire-payeur"
        name="nouveauCommentaire"
        value={nouveauCommentaire || ''}
        onChange={handleNouveauCommentaireChange}
        rows={1}
        placeholder="Saisir un commentaire relatif au payeur"
      />
    ),
    [nouveauCommentaire, handleNouveauCommentaireChange],
  );

  const textAreaGroupContainerClasses = React.useMemo(() => {
    const classes = ['text-area-group-container'];

    if (_.some(errors, { id: 'commentaire' })) {
      classes.push('field error');
    }

    return classes.join(' ');
  }, [errors]);

  return (
    <Grid as={Form}>
      <Grid.Row>
        <Grid.Column
          style={{ display: 'flex', alignItems: 'center' }}
          className={textAreaGroupContainerClasses}
        >
          <PopupRGPD />
          {_.isEmpty(_.trim(commentaire)) ? (
            textArea
          ) : (
            <div className="text-area-group">
              {textArea}
              <Divider horizontal>
                <span>Historique des commentaires du payeur</span>
              </Divider>
              <TextArea
                data-testid="textarea-histo-commentaire-payeur"
                name="commentaire"
                value={_.trim(commentaire) || ''}
                onChange={(e, { name, value }) => onChange({ identifiant, [name]: value })}
                rows={2}
              />
            </div>
          )}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default PayeurPanelCommentaire;
